// extracted by mini-css-extract-plugin
export var card = "_ik-5";
export var cardSelected = "_ik-4";
export var image = "_ik-3";
export var modal = "_ik-0";
export var modalContent = "_ik-1";
export var table = "_ik-2";